import { render, staticRenderFns } from "./letter.vue?vue&type=template&id=24db606a&"
import script from "./letter.vue?vue&type=script&lang=js&"
export * from "./letter.vue?vue&type=script&lang=js&"
import style0 from "./letter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports